/* eslint-disable */
/* tslint:disable */
/*
 * DO NOT EDIT THIS FILE!
 * YOUR CHANGES WILL BE OVERWRITTEN!
 * FILE IS BASED ON .wuf/testkits/vanilla.template.ejs
 * AND GENERATED BY `wuf export-testkits`
 */
import {
  testkitFactoryCreator,
  uniTestkitFactoryCreator,
} from '@wix/wix-ui-test-utils/vanilla';
import { jsdomReactUniDriver as jsdomReactLegacyUniDriver } from '@wix/unidriver-jsdom-react-legacy';
import { setUniDriverImplementation } from "../test/unidriver-config"

setUniDriverImplementation(jsdomReactLegacyUniDriver)


import { accordionDriverFactory } from '../components/Accordion/Accordion.driver';
export const accordionTestkitFactory = uniTestkitFactoryCreator(accordionDriverFactory);

import { actionsMenuLayoutDriverFactory } from '../components/ActionsMenuLayout/ActionsMenuLayout.driver';
export const actionsMenuLayoutTestkitFactory = uniTestkitFactoryCreator(actionsMenuLayoutDriverFactory);

import { addItemDriverFactory } from '../components/AddItem/AddItem.driver';
export const addItemTestkitFactory = uniTestkitFactoryCreator(addItemDriverFactory);

import { autocompleteDriverFactory } from '../components/Autocomplete/Autocomplete.legacy.driver';
export const autocompleteTestkitFactory = testkitFactoryCreator(autocompleteDriverFactory);

import { avatarDriverFactory } from '../components/Avatar/Avatar.driver';
export const avatarTestkitFactory = uniTestkitFactoryCreator(avatarDriverFactory);

import { avatarGroupDriverFactory } from '../components/AvatarGroup/AvatarGroup.driver';
export const avatarGroupTestkitFactory = uniTestkitFactoryCreator(avatarGroupDriverFactory);

import { badgeDriverFactory } from '../components/Badge/Badge.driver';
export const badgeTestkitFactory = uniTestkitFactoryCreator(badgeDriverFactory);

import { boxSelectionDriverFactory } from '../components/BoxSelection/BoxSelection.driver';
export const boxSelectionTestkitFactory = uniTestkitFactoryCreator(boxSelectionDriverFactory);

import { breadcrumbsDriverFactory } from '../components/Breadcrumbs/Breadcrumbs.driver';
export const breadcrumbsTestkitFactory = uniTestkitFactoryCreator(breadcrumbsDriverFactory);

import { buttonDriverFactory } from '../components/Button/Button.driver';
export const buttonTestkitFactory = uniTestkitFactoryCreator(buttonDriverFactory);

import { calendarCellDriverFactory } from '../components/CalendarCell/CalendarCell.driver';
export const calendarCellTestkitFactory = uniTestkitFactoryCreator(calendarCellDriverFactory);

import { calendarPopoverDriverFactory } from '../components/CalendarPopover/CalendarPopover.driver';
export const calendarPopoverTestkitFactory = uniTestkitFactoryCreator(calendarPopoverDriverFactory);

import { cardDriverFactory } from '../components/Card/Card.driver';
export const cardTestkitFactory = uniTestkitFactoryCreator(cardDriverFactory);

import { checkboxDriverFactory } from '../components/Checkbox/Checkbox.driver';
export const checkboxTestkitFactory = uniTestkitFactoryCreator(checkboxDriverFactory);

import { checkboxGroupDriverFactory } from '../components/CheckboxGroup/CheckboxGroup.driver';
export const checkboxGroupTestkitFactory = uniTestkitFactoryCreator(checkboxGroupDriverFactory);

import { colorPickerDriverFactory } from '../components/ColorPicker/ColorPicker.driver';
export const colorPickerTestkitFactory = uniTestkitFactoryCreator(colorPickerDriverFactory);

import { copyUrlButtonDriverFactory } from '../components/CopyUrlButton/CopyUrlButton.driver';
export const copyUrlButtonTestkitFactory = uniTestkitFactoryCreator(copyUrlButtonDriverFactory);

import { counterDriverFactory } from '../components/Counter/Counter.driver';
export const counterTestkitFactory = uniTestkitFactoryCreator(counterDriverFactory);

import { counterBadgeDriverFactory } from '../components/CounterBadge/CounterBadge.driver';
export const counterBadgeTestkitFactory = uniTestkitFactoryCreator(counterBadgeDriverFactory);

import { customDialogDriverFactory } from '../components/CustomDialog/CustomDialog.driver';
export const customDialogTestkitFactory = uniTestkitFactoryCreator(customDialogDriverFactory);

import { datePickerInputDriverFactory } from '../components/DatePickerInput/DatePickerInput.driver';
export const datePickerInputTestkitFactory = uniTestkitFactoryCreator(datePickerInputDriverFactory);

import { datePickerInputOldDriverFactory } from '../components/DatePickerInputOld/DatePickerInputOld.driver';
export const datePickerInputOldTestkitFactory = uniTestkitFactoryCreator(datePickerInputOldDriverFactory);

import { dialogDriverFactory } from '../components/Dialog/Dialog.driver';
export const dialogTestkitFactory = uniTestkitFactoryCreator(dialogDriverFactory);

import { dotNavigationDriverFactory } from '../components/DotNavigation/DotNavigation.driver';
export const dotNavigationTestkitFactory = uniTestkitFactoryCreator(dotNavigationDriverFactory);

import { dropdownDriverFactory } from '../components/Dropdown/Dropdown.driver';
export const dropdownTestkitFactory = uniTestkitFactoryCreator(dropdownDriverFactory);

import { eventDriverFactory } from '../components/Event/Event.driver';
export const eventTestkitFactory = uniTestkitFactoryCreator(eventDriverFactory);

import { fileUploadDriverFactory } from '../components/FileUpload/FileUpload.driver';
export const fileUploadTestkitFactory = uniTestkitFactoryCreator(fileUploadDriverFactory);

import { floatingDropdownDriverFactory } from '../components/FloatingDropdown/FloatingDropdown.driver';
export const floatingDropdownTestkitFactory = uniTestkitFactoryCreator(floatingDropdownDriverFactory);

import { gridDriverFactory } from '../components/Grid/Grid.driver';
export const gridTestkitFactory = uniTestkitFactoryCreator(gridDriverFactory);

import { heroImageDriverFactory } from '../components/HeroImage/HeroImage.driver';
export const heroImageTestkitFactory = uniTestkitFactoryCreator(heroImageDriverFactory);

import { iconButtonDriverFactory } from '../components/IconButton/IconButton.driver';
export const iconButtonTestkitFactory = uniTestkitFactoryCreator(iconButtonDriverFactory);

import { iconToggleDriverFactory } from '../components/IconToggle/IconToggle.driver';
export const iconToggleTestkitFactory = uniTestkitFactoryCreator(iconToggleDriverFactory);

import { iconTooltipDriverFactory } from '../components/IconTooltip/IconTooltip.driver';
export const iconTooltipTestkitFactory = uniTestkitFactoryCreator(iconTooltipDriverFactory);

import { imageDriverFactory } from '../components/Image/Image.driver';
export const imageTestkitFactory = uniTestkitFactoryCreator(imageDriverFactory);

import { inputDriverFactory } from '../components/Input/Input.legacy.driver';
export const inputTestkitFactory = testkitFactoryCreator(inputDriverFactory);

import { inputDialogDriverFactory } from '../components/InputDialog/InputDialog.driver';
export const inputDialogTestkitFactory = uniTestkitFactoryCreator(inputDialogDriverFactory);

import { legacyCardDriverFactory } from '../components/LegacyCard/LegacyCard.driver';
export const legacyCardTestkitFactory = uniTestkitFactoryCreator(legacyCardDriverFactory);

import { likeButtonDriverFactory } from '../components/LikeButton/LikeButton.driver';
export const likeButtonTestkitFactory = uniTestkitFactoryCreator(likeButtonDriverFactory);

import { mediaLabelDriverFactory } from '../components/MediaLabel/MediaLabel.driver';
export const mediaLabelTestkitFactory = uniTestkitFactoryCreator(mediaLabelDriverFactory);

import { mobileDrawerDriverFactory } from '../components/MobileDrawer/MobileDrawer.driver';
export const mobileDrawerTestkitFactory = uniTestkitFactoryCreator(mobileDrawerDriverFactory);

import { overlappingCardDriverFactory } from '../components/OverlappingCard/OverlappingCard.driver';
export const overlappingCardTestkitFactory = uniTestkitFactoryCreator(overlappingCardDriverFactory);

import { paginationDriverFactory } from '../components/Pagination/Pagination.driver';
export const paginationTestkitFactory = uniTestkitFactoryCreator(paginationDriverFactory);

import { pickerDriverFactory } from '../components/Picker/Picker.driver';
export const pickerTestkitFactory = uniTestkitFactoryCreator(pickerDriverFactory);

import { popoverDriverFactory } from '../components/Popover/Popover.driver';
export const popoverTestkitFactory = uniTestkitFactoryCreator(popoverDriverFactory);

import { progressBarDriverFactory } from '../components/ProgressBar/ProgressBar.driver';
export const progressBarTestkitFactory = uniTestkitFactoryCreator(progressBarDriverFactory);

import { radioButtonDriverFactory } from '../components/RadioButton/RadioButton.driver';
export const radioButtonTestkitFactory = uniTestkitFactoryCreator(radioButtonDriverFactory);

import { radioButtonGroupDriverFactory } from '../components/RadioButtonGroup/RadioButtonGroup.driver';
export const radioButtonGroupTestkitFactory = uniTestkitFactoryCreator(radioButtonGroupDriverFactory);

import { rangeDriverFactory } from '../components/Range/Range.driver';
export const rangeTestkitFactory = uniTestkitFactoryCreator(rangeDriverFactory);

import { ratingsDriverFactory } from '../components/Ratings/Ratings.driver';
export const ratingsTestkitFactory = uniTestkitFactoryCreator(ratingsDriverFactory);

import { ratingsInputDriverFactory } from '../components/RatingsInput/RatingsInput.driver';
export const ratingsInputTestkitFactory = uniTestkitFactoryCreator(ratingsInputDriverFactory);

import { reactionsDriverFactory } from '../components/Reactions/Reactions.driver';
export const reactionsTestkitFactory = uniTestkitFactoryCreator(reactionsDriverFactory);

import { reviewSummaryDriverFactory } from '../components/ReviewSummary/ReviewSummary.driver';
export const reviewSummaryTestkitFactory = uniTestkitFactoryCreator(reviewSummaryDriverFactory);

import { ribbonDriverFactory } from '../components/Ribbon/Ribbon.driver';
export const ribbonTestkitFactory = uniTestkitFactoryCreator(ribbonDriverFactory);

import { sectionNotificationDriverFactory } from '../components/SectionNotification/SectionNotification.driver';
export const sectionNotificationTestkitFactory = uniTestkitFactoryCreator(sectionNotificationDriverFactory);

import { shareButtonDriverFactory } from '../components/ShareButton/ShareButton.driver';
export const shareButtonTestkitFactory = uniTestkitFactoryCreator(shareButtonDriverFactory);

import { skeletonLineDriverFactory } from '../components/SkeletonLine/SkeletonLine.driver';
export const skeletonLineTestkitFactory = uniTestkitFactoryCreator(skeletonLineDriverFactory);

import { socialBarDriverFactory } from '../components/SocialBar/SocialBar.driver';
export const socialBarTestkitFactory = uniTestkitFactoryCreator(socialBarDriverFactory);

import { spinnerDriverFactory } from '../components/Spinner/Spinner.driver';
export const spinnerTestkitFactory = uniTestkitFactoryCreator(spinnerDriverFactory);

import { statesButtonDriverFactory } from '../components/StatesButton/StatesButton.driver';
export const statesButtonTestkitFactory = uniTestkitFactoryCreator(statesButtonDriverFactory);

import { stripCardDriverFactory } from '../components/StripCard/StripCard.driver';
export const stripCardTestkitFactory = uniTestkitFactoryCreator(stripCardDriverFactory);

import { tabbedContentDriverFactory } from '../components/TabbedContent/TabbedContent.driver';
export const tabbedContentTestkitFactory = uniTestkitFactoryCreator(tabbedContentDriverFactory);

import { tabsDriverFactory } from '../components/Tabs/Tabs.driver';
export const tabsTestkitFactory = uniTestkitFactoryCreator(tabsDriverFactory);

import { tagDriverFactory } from '../components/Tag/Tag.driver';
export const tagTestkitFactory = uniTestkitFactoryCreator(tagDriverFactory);

import { tagsDriverFactory } from '../components/Tags/Tags.driver';
export const tagsTestkitFactory = uniTestkitFactoryCreator(tagsDriverFactory);

import { textDriverFactory } from '../components/Text/Text.legacy.driver';
export const textTestkitFactory = testkitFactoryCreator(textDriverFactory);

import { textAreaDriverFactory } from '../components/TextArea/TextArea.driver';
export const textAreaTestkitFactory = uniTestkitFactoryCreator(textAreaDriverFactory);

import { textButtonDriverFactory } from '../components/TextButton/TextButton.driver';
export const textButtonTestkitFactory = uniTestkitFactoryCreator(textButtonDriverFactory);

import { textFieldDriverFactory } from '../components/TextField/TextField.legacy.driver';
export const textFieldTestkitFactory = testkitFactoryCreator(textFieldDriverFactory);

import { threeDotsLoaderDriverFactory } from '../components/ThreeDotsLoader/ThreeDotsLoader.driver';
export const threeDotsLoaderTestkitFactory = uniTestkitFactoryCreator(threeDotsLoaderDriverFactory);

import { thumbnailImageDriverFactory } from '../components/ThumbnailImage/ThumbnailImage.driver';
export const thumbnailImageTestkitFactory = uniTestkitFactoryCreator(thumbnailImageDriverFactory);

import { toastDriverFactory } from '../components/Toast/Toast.driver';
export const toastTestkitFactory = uniTestkitFactoryCreator(toastDriverFactory);

import { toggleSwitchDriverFactory } from '../components/ToggleSwitch/ToggleSwitch.driver';
export const toggleSwitchTestkitFactory = uniTestkitFactoryCreator(toggleSwitchDriverFactory);

import { tooltipDriverFactory } from '../components/Tooltip/Tooltip.legacy.driver';
export const tooltipTestkitFactory = testkitFactoryCreator(tooltipDriverFactory);

import { weeklyDateNavigationDriverFactory } from '../components/WeeklyDateNavigation/WeeklyDateNavigation.driver';
export const weeklyDateNavigationTestkitFactory = uniTestkitFactoryCreator(weeklyDateNavigationDriverFactory);

import { weeklyDatePickerDriverFactory } from '../components/WeeklyDatePicker/WeeklyDatePicker.driver';
export const weeklyDatePickerTestkitFactory = uniTestkitFactoryCreator(weeklyDatePickerDriverFactory);

import { wowImageDriverFactory } from '../components/WowImage/WowImage.driver';
export const wowImageTestkitFactory = uniTestkitFactoryCreator(wowImageDriverFactory);

